import request from '../utils'

const kpiApi = {
    kpiList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/kpi`)
        const res = await req;
        return res.body;
    },
    kpiDetail: async (modelingId, keyPerformanceIndicator) => {
        const req = request.get(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicator}`)
        const res = await req;
        return res.body;
    },
    kpiUpdate: async (modelingId, keyPerformanceIndicator) => {
        const req = request.put(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicator.id}`).send(keyPerformanceIndicator);
        const res = await req;
        return res.body;
    },
    kpiCreate: async (modelingId, keyPerformanceIndicator) => {
        const req = request.post(`/api/modeling/${modelingId}/kpi`).send(keyPerformanceIndicator);
        const res = await req;
        return res.body;
    },
    kpiDelete: async (modelingId, keyPerformanceIndicatorId) => {
        const req = request.delete(`/api/modeling/${modelingId}/kpi/${keyPerformanceIndicatorId}`);
        await req;
    },
    updateKPIOrder: async (modelingId, kpiList) => {
        const req = request.put(`/api/modeling/${modelingId}/kpi/updateorder`).send(kpiList);
        const res = await req;
        return res.body;
    }
};

export default kpiApi